import { Button } from '@design-system';
import { Loader, X } from 'lucide-react';

interface BulkActionBarProps {
  count: number;
  applying: boolean;
  error: string | null;
  onApply: () => void;
  onClear: () => void;
}

export function BulkActionBar({ count, applying, error, onApply, onClear }: BulkActionBarProps) {
  const label = count === 1 ? 'option' : 'options';
  return (
    <div className="border-border bg-background fixed inset-x-0 bottom-0 z-40 border-t shadow-lg">
      <div className="mx-auto max-w-5xl px-4 py-3">
        {error && <p className="mb-2 text-sm text-red-600">{error}</p>}
        <div className="flex flex-wrap items-center justify-between gap-3">
          <span className="text-sm text-gray-700">
            <strong>{count}</strong> {label} selected
          </span>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onClear}
              disabled={applying}
              aria-label="Clear selection"
            >
              <X className="mr-1 size-4" />
              Clear
            </Button>
            <Button size="sm" onClick={onApply} disabled={applying}>
              {applying && <Loader className="mr-1 size-4 animate-spin" />}
              Apply {count} {label}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
